import TiposPessoa from "../../models/enum/tiposPessoa";
import TransportadoraModel from "../../models/transporte/transportadoraModel";
import nfetch from "../../utils/events/nfetch";
import { IService } from "../base/iService";

export default class TransportadoraService extends IService<TransportadoraModel> {
    constructor() {
        super("Transportadora");
    }

    public getByDocumento(tipoPessoa: TiposPessoa, documento: string): Promise<Response> {
        return nfetch(`/${this.controllerName}/GetByDocumento?tipoPessoa=${tipoPessoa}&documento=${documento}`, {
            credentials: "same-origin",
        });
    }

    public insertWithLogo(model: TransportadoraModel, logo?: File): Promise<Response> {
        const data = new FormData();
        data.append("transportadoraJson", JSON.stringify(model));

        if (logo) {
            data.append("logo", logo);
        }

        return nfetch(`/${this.controllerName}/InsertWithLogo`, {
            method: "post",
            credentials: "same-origin",
            body: data,
        });
    }

    public updateWithLogo(model: TransportadoraModel, logo?: File): Promise<Response> {
        const data = new FormData();
        data.append("transportadoraJson", JSON.stringify(model));

        if (logo) {
            data.append("logo", logo);
        }

        return nfetch(`/${this.controllerName}/UpdateWithLogo`, {
            method: "post",
            credentials: "same-origin",
            body: data,
        });
    }
}
